export interface ProjectItem {
  id: string;
  title: string;
  status: string;
  generationMode?: "standard" | "html" | "image";
  progressPercent?: number;
  createdAt?: string;
  updatedAt?: string;
  archivedAt?: string;
  errorMessage?: string;
  coverThumbnailUrl?: string;
  storageBytes?: number;
  storageMeasuredAt?: string;
  hasAvailableStandardResult?: boolean;
  currentProductCode?: string | null;
}

export function projectListDisplayStatus(project: Pick<ProjectItem, "status" | "archivedAt" | "hasAvailableStandardResult" | "currentProductCode">): string {
  if (project.archivedAt) return "archived";
  const canFallBackToStandardResult = project.hasAvailableStandardResult
    && project.currentProductCode === "advanced-beautify-image2";
  return canFallBackToStandardResult ? "succeeded" : project.status;
}

export function projectListStatusGroup(project: Pick<ProjectItem, "status" | "archivedAt" | "hasAvailableStandardResult" | "currentProductCode">): string {
  const status = projectListDisplayStatus(project);
  if (status === "archived") return "archived";
  if (status === "succeeded") return "done";
  if (["failed", "cancelled"].includes(status)) return "failed";
  if (["draft", "waiting_outline", "ready_to_generate"].includes(status)) return "draft";
  return "running";
}

export interface UserStorageOverview {
  usedBytes: number;
  quotaBytes: number;
  quotaMb: number;
  measuredAt?: string;
  overQuota: boolean;
  blocked: boolean;
  enforceLimit: boolean;
  audience: "member" | "non_member";
  membershipPlan?: string;
}

export interface ProjectListResponse {
  tasks: ProjectItem[];
  storage?: UserStorageOverview;
  coverBackfillScheduled?: boolean;
}

export const PROJECT_COVER_BACKFILL_REFRESH_MS = 8_000;

export interface WorkspaceOutletContext {
  projects?: ProjectItem[];
  storage?: UserStorageOverview;
  projectError: string;
}
